//@flow
import React, { Component } from 'react';
import { connect } from "react-redux";
import { CTAButton, Wrapper } from "h-signup";
import SVG from 'react-svg-inline';
import { Title, SubTitle, Avatar } from "../GetStarted/styledComponents";
import { DownloadButton, RedirectText } from './styledComponents'
import { clearState } from '../../../../../localStorage'
import { sendGenricTrackingEvent } from 'h-commons';
import { SubTitleStyle } from '../Verify/styledComponents';
class Success extends Component<Props, State> {
	clockCall: any;

	constructor(props: Props) {
		super(props);
		this.state = {
			countDownValue: 3,
			isClicked: false,
			opacity: 0,
			extensionInstalled: document.getElementById("hiverhq_extension_version") ? true : false,
			pageTitle: '',
			successMessage: '',
			isDataSet: false
        }
	}

	componentDidMount() {
		this.setSuccessMessage();
	}

	static getDerivedStateFromProps(props, state) {
		let { firstName, inviterName, isUserInvited} = props;
		let { isDataSet, extensionInstalled } = state;
		// if all the user details and the extension availability is set
		if( isUserInvited && firstName && inviterName && isDataSet){
			return {
				pageTitle: `Hey ${firstName}!`,
				successMessage: `Guess what, ${inviterName} from your team has already sent you an invite.\n\nAll you have to do now is ${ extensionInstalled ? "go to Gmail" : "install the Hiver extension"}, and accept the invitation. And, you're good to go! `
			};
		}
		return null;
	}

	setExtensionAvailability() { 
		const { extensionInstalled } = this.state;
		let pageTitle = "Well done! You’re almost there";
		let successMessage = "Install our Chrome extension and get started with managing your shared mailboxes.";
		let img = new Image(); 
		const chromeExtensionID = 'fcinnggknmdfkilogcndkgpojpfojeem';
		img.src = `chrome-extension://${chromeExtensionID}/square_16.png`; 
		if(extensionInstalled) {
			pageTitle = "Congratulations!";
			successMessage = "You're all set.";
		}
		this.setState({
			pageTitle: pageTitle,
			successMessage: successMessage,
			isDataSet: true
		});
	}

	setSuccessMessage() {
		const { isUserInvited } = this.props;
		const { extensionInstalled } = this.state;
		if (isUserInvited) {
			this.setExtensionAvailability();
		} else if(extensionInstalled){
			this.setState({
				extensionInstalled: true,
				pageTitle: 'Congratulations!',
				successMessage: "You're all set."
			});
		} else{
			this.setState({
				pageTitle: 'Well done! You’re almost there.',
				successMessage: 'Install our Chrome extension and get started with managing your shared mailboxes.'
			});
		}
	}

	navigateToUrl = (navigateTo) => {
		window.location.href = navigateTo;
	}

	handleDownloadClick = () => {
		this.setState({isClicked: true, opacity: 1});
		sendGenricTrackingEvent('clickedChromeExtensionInstall',{ userid: this.props.userid });
		this.clockCall = setInterval(() => this.countDown(), 1000);
	}

	countDown = () => {  
		if(this.state.countDownValue == 1) {
			clearState();
			const navigateTo = "https://chrome.google.com/webstore/detail/shared-mailbox-shared-gma/fcinnggknmdfkilogcndkgpojpfojeem";
			clearInterval(this.clockCall)
			this.navigateToUrl(navigateTo);
			return;
		}
		this.setState((prevState) => ({
			countDownValue: prevState.countDownValue - 1 
		}));
	};

	renderAvatar = () => {
		const {avatarUrl, isUserInvited} = this.props;
		if (isUserInvited){
			return (
				<Avatar>
					{ avatarUrl && <img src={avatarUrl}/> }
				</Avatar>
			);
		}
		return null;
	}

	renderNavigationMessage = () => {
		const { successMessage, pageTitle } = this.state;
		return (
			<div>
				<Title>{pageTitle}</Title>
				<SubTitle style={SubTitleStyle}>
					{successMessage}
				</SubTitle>
			</div>
		)
	}

	renderButton() {
		const { isClicked, extensionInstalled } = this.state;
		const { email, isUserInvited} = this.props;
		const gmailUrl = `http://mail.google.com/mail/u?authuser=${email}`
		if(!isClicked && !extensionInstalled){
			return(
				<DownloadButton onClick={this.handleDownloadClick}>
					<SVG 
						className="flaunt-download" 
						svg={require('../../../../common/images/chrome-webstore-button.svg')} 
						width="198px"
						height="41px"
					/>
				</DownloadButton>
			)
		}
		else if(isClicked && !extensionInstalled){
			return <RedirectText style={{ opacity: this.state.opacity }}>
				<p>Taking you to the Chrome WebStore</p> 
				<div className="loading-dots">
					<span className="dot one">.</span><span className="dot two">.</span><span className="dot three">.</span>
				</div>
			</RedirectText>
		}
		else {
			return(
				<CTAButton 
					width="294px" 
					onClick={()=>this.navigateToUrl(gmailUrl)}
				>
					{isUserInvited ? "Take me to Gmail" : "Go to Gmail"}
				</CTAButton>
			)
		}
	}
	

	render() {
		if (!this.state.pageTitle || !this.state.successMessage){
			return null;
		}
		return (
			<Wrapper height="81%">
				{this.renderAvatar()}
				{this.renderNavigationMessage()}
				{this.renderButton()}
			</Wrapper>			
		)
	}
}

type Props = {
	skipMailboxCreation: boolean,
	isUserInvited: boolean,
	email: string,
	firstName: string,
	avatarUrl: string,
	inviterName: string
};

type State = {
	countDownValue: number,
	isClicked: boolean,
	opacity: number,
	extensionInstalled: boolean,
	pageTitle: string,
	successMessage: string,
	isDataSet: boolean
};

const mapStateToProps = ({ smData, userDetails }) => ({
	skipMailboxCreation: smData.skipMailboxCreation,
	isUserInvited: userDetails.isUserInvited,
	email: userDetails.email,
	firstName: userDetails.firstName,
	avatarUrl: userDetails.avatarUrl,
	inviterName: userDetails.inviterName,
	userId: userDetails.id
});

export default connect(mapStateToProps)(Success);

